import SocialMedia from "components/About/SocialMedia";
import HeroConsulting from "components/Consulting/HeroConsulting";
import ListConsults from "components/Consulting/ListConsults";
import MissionConsult from "components/Consulting/MissionConsult";
import QuoteConsult from "components/Consulting/QuoteConsult";
import LatestWorkshop from "components/Homepage/LatestWorkshop";
import PriceSection from "components/Service/PriceSection";
import React from "react";

const Consulting = () => {
  return (
    <div>
      <HeroConsulting />
      <QuoteConsult />
      <MissionConsult />
      <ListConsults />
      <PriceSection />
    </div>
  );
};

export default Consulting;
